import React from 'react'

function FlowNode({ 
  id, 
  className = '', 
  children, 
  active = false, 
  processing = false,
  success = false,
  error = false,
  onClick = null,
  clickable = false
}) {
  const getNodeClasses = () => {
    const classes = ['flow-node', className]
    
    if (active) classes.push('active')
    if (processing) classes.push('processing')
    if (success) classes.push('success')
    if (error) classes.push('error')
    if (clickable) classes.push('clickable')
    
    return classes.join(' ')
  }

  const handleClick = (e) => {
    e.stopPropagation()
    if (onClick) {
      onClick()
    }
  }

  return (
    <div 
      id={id}
      className={getNodeClasses()}
      onClick={clickable ? handleClick : undefined}
      style={{ cursor: clickable ? 'pointer' : 'default' }}
    >
      {children}
      {clickable && className.includes('memory-node') && (
        <i className="fas fa-external-link-alt click-indicator"></i>
      )}
    </div>
  )
}

export default FlowNode
